import HorizontalDateBox from '@sophocles/components/HorizontalDateBox/HorizontalDateBox';

export default HorizontalDateBox;
